import { Suspense } from 'react';
import { Modal, ModalHeader } from '#components/patterns/modal/index.ts';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { DeleteNetworkModalBody } from './DeleteNetworkModalBody.tsx';

type Props = {
  networkId: string;
  onClose: () => void;
  onDelete: () => void;
};

/**
 * This modal is mostly just a wrapper to allow us to have a suspense boundary in the modal,
 * so that when a user tries to delete a network, we don't replace the table with a spinner.
 * Instead, the modal window will open immediately, and will contain a spinner until we know
 * what UI to show inside.
 */
export function DeleteNetworkModal({ networkId, onClose, onDelete }: Props) {
  return (
    <Modal isOpen={true} onClose={onClose} shouldRestoreFocusViaFocusScope={true}>
      <ModalHeader>Delete network</ModalHeader>
      <Suspense
        fallback={
          <div style={{ height: 220 }}>
            <LoadingSpinner />
          </div>
        }
      >
        <DeleteNetworkModalBody networkId={networkId} onCancel={onClose} onDelete={onDelete} />
      </Suspense>
    </Modal>
  );
}
